import { Injectable } from '@angular/core';
import { GoogleLoginProvider } from '@abacritt/angularx-social-login';
import { environment } from '../../../environments/environment';
import { isGoogleSignInHost } from './google-sign-in-host';

/**
 * Configuration de @abacritt/angularx-social-login (« SocialAuthServiceConfig »).
 *
 * La connexion Google n'est proposée que sur les domaines web-atrio.com : ailleurs,
 * aucun fournisseur n'est déclaré, la bibliothèque ne charge donc pas le script
 * accounts.google.com/gsi/client (il n'est plus dans index.html).
 */
@Injectable({
  providedIn: 'root'
})
export class OverrideSocialAuthService {
  public providers: unknown[] = [];

  public onError(_err: unknown) {}

  constructor() {
    if (isGoogleSignInHost()) {
      this.providers.push({
        id: GoogleLoginProvider.PROVIDER_ID,
        provider: new GoogleLoginProvider(environment.google_client_id),
        autoLogin: false,
        lang: 'fr',
        onError: (err: unknown) => this.onError(err)
      });
    }
  }
}
